import React from 'react';
import './StatsBar.css';

const stats = [
  { num: '500+', label: 'Candidates Placed', accent: 'blue' },
  { num: '8+', label: 'Support Services', accent: 'coral' },
  { num: '100%', label: 'Success Rate', accent: 'mint' },
  { num: '5+', label: 'Years Experience', accent: 'gold' },
];

export default function StatsBar() {
  return (
    <section className="stats-band" aria-label="Company highlights">
      <div className="stats-bar">
        {stats.map((stat, index) => (
          <div
            key={stat.label}
            className={`stat-item stat-${stat.accent}`}
            style={{ animationDelay: `${index * 120}ms` }}
          >
            <div className="stat-glow" />
            <div className="stat-num">{stat.num}</div>
            <div className="stat-label">{stat.label}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
